import { referrerURL } from '@/utils/referrer';
import { WALLET_RESIZE_MESSAGE } from './messages.js';

function resizeWidget(expanded: boolean) {
  if (__STANDALONE_MODE__) {
    return;
  }

  window.parent.postMessage(
    { type: WALLET_RESIZE_MESSAGE, expanded },
    referrerURL,
  );
}

export function expandWidget() {
  resizeWidget(true);
}

export function collapseWidget() {
  resizeWidget(false);
}
